module.exports = __webpack_public_path__ + "static/media/lizetta_mihaila.2c782694.JPG";